export type UserType = 'all' | 'shop_staff' | 'wearista' | 'others'

export type UserTypeId = 0 | 1 | 2 | 3

export const userTypeToIdMap: Record<UserType, UserTypeId> = {
  all: 0,
  shop_staff: 1,
  wearista: 2,
  others: 3,
}

const idToUserTypeMap = Object.fromEntries(
  Object.entries(userTypeToIdMap).map(([u, id]) => [id, u])
)
export const getUserTypeFromUserTypeId = (id: number): UserType | undefined => {
  if (Object.values(userTypeToIdMap).includes(id)) return idToUserTypeMap[id]
  return undefined
}
export const getUserTypeIdFromUserType = (c: UserType): number | undefined =>
  userTypeToIdMap[c]

export const getUserTypeLabelFromUserType = (userType: UserType) => {
  switch (userType) {
    case 'all':
      return 'すべて'
    case 'shop_staff':
      return 'ショップスタッフ'
    case 'wearista':
      return 'WEARISTA'
    case 'others':
      return '一般'
  }
}
